export function getUtc(date: Date | string): Date {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return date;
}
